// Libs
import React, { useCallback, Fragment } from "react";
import { useQueryParam, StringParam } from "use-query-params";
import { gaEvent } from "../../../../utils/trackEvents";

// Components
import { Li } from "./ItemStyle";

const Item = ({
  focus,
  index,
  result,
  setFocus,
  setResults,
  setSelectedSuggestedWord,
  searchTerm
}) => {
  // query parameters with serialization
  const setKeywords = useQueryParam("keywords", StringParam)[1];

  /**
   * Case insensitive highlight which keeps the source casing.
   * @param {string} source text
   * @param {string} target to highlight within the source text
   */
  const highlightWord = (source, target) => {
    const regex = new RegExp(`(${target})`, "gi");
    const match = source.match(regex);

    if (match != null) {
      const parts = source.split(match[0], 2);

      return (
        <Fragment>
          <strong>{parts[0]}</strong>
          {match[0]}
          <strong>{parts[1]}</strong>
        </Fragment>
      );
    } else {
      return source;
    }
  };

  const handleSelect = useCallback(
    () => {
      // setting focus to that element when it is selected
      setFocus(index);
    },
    [index, setFocus]
  );

  return (
    <Li
      tabIndex={focus ? 0 : -1}
      role="button"
      onClick={() => {
        setKeywords(result, "pushIn");
        gaEvent({ category: "Search Page", action: "Suggestion Clicked" });
        setSelectedSuggestedWord(result);
        setResults([]);
      }}
      onKeyPress={handleSelect}
    >
      {highlightWord(result, searchTerm)}
    </Li>
  );
};

export default Item;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/header/autocomplete/Item.js